import { portalText } from "../../i18n/portal.js";
/**
 * The hand-off route, built here so `router.tsx` gains exactly one entry (plan-002 RB-18).
 *
 * A child of the ROOT, never of the shell: the tab this opens holds no session on this origin
 * until the hand-off is redeemed, and the shell's guard would send it to log in first.
 */
import { createRoute, type AnyRoute } from "@tanstack/react-router";

import { ImpersonationHandoffScreen } from "./impersonation-handoff-screen.js";

export function impersonationHandoffRouteUnder<TParent extends AnyRoute>(parent: TParent) {
  return createRoute({
    getParentRoute: () => parent,
    path: "/impersonation/$grantId",
    staticData: { pageTitle: portalText("core", "impersonation.opening_a_support_session_c4b017") },
    component: ImpersonationHandoffScreen,
  });
}
